import { Fragment } from 'react';
import { Card, Divider, Grid, Stack, Typography } from '@mui/material';
import { BORDER_MAIN, BORDER_RADIUS_L, useBreakpoints } from 'shared';

import { statCards } from '../constants';

export const TokenCitStats = () => {
  const { isDownMdLayout } = useBreakpoints();

  return (
    <Card
      sx={{
        width: '100%',
        px: 2.5,
        py: 2,
        borderRadius: BORDER_RADIUS_L,
        border: BORDER_MAIN,
        boxShadow: 'none',
        marginTop: { xs: '64px', md: '120px' },
      }}
    >
      <Grid container rowSpacing={{ xs: 1.5, md: 0 }}>
        {statCards.map(({ label, value, accent }, index) => {
          const last = index === statCards.length - 1;
          const even = index % 2 === 0;

          return (
            <Fragment key={label}>
              <Grid item xs={6} md={3}>
                <Stack
                  justifyContent="center"
                  sx={{
                    height: '100%',
                    pr: {
                      xs: even ? 2 : 0,
                      md: last ? 0 : 2,
                    },
                    pl: {
                      xs: even ? 0 : 2,
                      md: index === 0 ? 0 : 2,
                    },
                    borderRight: {
                      xs: even ? BORDER_MAIN : 'none',
                      md: last ? 'none' : BORDER_MAIN,
                    },
                  }}
                >
                  <Typography variant="body1" className="secondary">
                    {label}
                  </Typography>
                  <Typography
                    variant="h4"
                    className={accent ? 'accent' : ''}
                    sx={{
                      mt: 1,
                      wordBreak: 'break-word',
                      fontSize: {
                        xs: 16,
                        md: 20,
                      },
                    }}
                  >
                    {value}
                  </Typography>
                </Stack>
              </Grid>
              {!even && !last && isDownMdLayout && (
                <Grid item xs={12}>
                  <Divider orientation="horizontal" sx={{ height: 'auto' }} />
                </Grid>
              )}
            </Fragment>
          );
        })}
      </Grid>
    </Card>
  );
};
